<fe-header style="z-index: 1000"></fe-header>
<fe-href-subheader [breadcrumbs]="breadcrumbs"></fe-href-subheader>
<fe-primary-container
    [content]="{
        title: 'Pre Check-In',
        subtitle: ('fe_precheckin_step0_h1_main_subtitle' | translate)
    }"
    [containerGutter]="'g-0 gx-md-16 gx-lmd-0'"
>
    <div
        class="container overflow-hidden g-0 gx-md-16 gx-lmd-0 container-type-login-help"
    >
        <div class="row gx-0 gx-lmd-9 gx-lg-17">
            <div class="col-12 col-lmd-6">
                <fe-primary-container
                    [content]="{
                        title:
                            ('fe_precheckin_step0_p_block_info_title'
                            | translate),
                        subtitle:
                            ('fe_precheckin_step0_p_block_info_subtitle'
                            | translate)
                    }"
                    [type]="'paragraph'"
                    [containerType]="'container-fluid'"
                >
                    <div
                        *ngIf="status === 'registered'"
                        class="container-fluid pb-10 mb-24 ms-19 ms-sm-0 container-forms"
                    >
                        <form [formGroup]="credentialsForm">
                            <div class="row gy-14 mb-10 justify-content-end">
                                <div class="col-auto">
                                    <fe-button
                                        (onClick)="onClickBack()"
                                        [btnClass]="
                                            'fw-normal p-0 d-flex align-items-center btn-back-edit'
                                        "
                                        [style]="'link'"
                                        [icon]="'arrow-right-yellow'"
                                        [iconPosition]="'left'"
                                        class="btn-edit-back"
                                        >{{
                                            'fe_precheckin_step0_button_txt_return'
                                                | translate
                                        }}</fe-button
                                    >
                                </div>
                            </div>
                            <div class="row gy-14">
                                <div class="col-12">
                                    <fe-input
                                        class="mb-10"
                                        [label]="
                                            'fe_precheckin_step0_input_placeholder_email'
                                                | translate
                                        "
                                        [type]="'email'"
                                        [formControlName]="'email'"
                                    ></fe-input>
                                </div>
                            </div>
                            <div class="row gy-14">
                                <div class="col-12">
                                    <fe-input
                                        class="mb-10"
                                        [label]="
                                            'fe_precheckin_step0_input_placeholder_password'
                                                | translate
                                        "
                                        [type]="'password'"
                                        [formControlName]="'password'"
                                    ></fe-input>
                                </div>
                            </div>
                            <div class="row gy-14">
                                <div class="col-12">
                                    <fe-button
                                        class="d-grid btn-search-reservation"
                                        [btnClass]="'px-9'"
                                        [style]="'primary'"
                                        [type]="'button'"
                                        (onClick)="onClickLogin()"
                                        [loading]="loadingBtnLogin"
                                    >
                                        {{
                                            'fe_precheckin_step0_button_txt_login'
                                                | translate
                                        }}
                                    </fe-button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div
                        *ngIf="status === 'guest'"
                        class="container-fluid pb-10 mb-24 ms-19 ms-sm-0 container-forms"
                    >
                        <form [formGroup]="guestForm">
                            <div class="row gy-14 mb-10 justify-content-end">
                                <div class="col-auto">
                                    <fe-button
                                        (onClick)="onClickBack()"
                                        [btnClass]="
                                            'fw-normal p-0 d-flex align-items-center btn-back-edit'
                                        "
                                        [style]="'link'"
                                        [icon]="'arrow-right-yellow'"
                                        [iconPosition]="'left'"
                                        class="btn-edit-back"
                                        >{{
                                            'fe_precheckin_step0_button_txt_return'
                                                | translate
                                        }}</fe-button
                                    >
                                </div>
                            </div>
                            <div class="row gy-14">
                                <div class="col-12">
                                    <fe-input
                                        class="mb-10"
                                        [label]="
                                            'fe_precheckin_step0_input_placeholder_email'
                                                | translate
                                        "
                                        [type]="'email'"
                                        [formControlName]="'email'"
                                    ></fe-input>
                                </div>
                            </div>
                            <div class="row gy-14">
                                <div class="col-12">
                                    <fe-input
                                        class="mb-10"
                                        [label]="
                                            'fe_precheckin_step0_input_placeholder_reservation_code'
                                                | translate
                                        "
                                        [formControlName]="'reservationCode'"
                                    ></fe-input>
                                </div>
                            </div>
                            <div class="row gy-14">
                                <div class="col-12">
                                    <fe-button
                                        class="d-grid btn-search-reservation"
                                        [btnClass]="'px-9'"
                                        [style]="'primary'"
                                        [type]="'button'"
                                        (onClick)="onClickStart()"
                                        [loading]="loadingBtnGuest"
                                    >
                                        {{
                                            'fe_precheckin_step0_button_txt_start'
                                                | translate
                                        }}
                                    </fe-button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div
                        *ngIf="status === 'initial'"
                        class="container-fluid pb-10 mb-24 ms-19 ms-sm-0 container-btns"
                    >
                        <div class="row gy-14">
                            <div class="col-12 mb-23">
                                <fe-button
                                    class="d-grid btn-continue-user"
                                    [btnClass]="'px-0'"
                                    [style]="'primary'"
                                    [type]="'button'"
                                    (onClick)="onClickContinueUser()"
                                >
                                    {{
                                        'fe_precheckin_step0_button_txt_registered'
                                            | translate
                                    }}
                                </fe-button>
                            </div>
                        </div>
                        <div class="row gy-14">
                            <div class="col-12">
                                <fe-button
                                    class="d-grid btn-search-reservation"
                                    [btnClass]="'px-9'"
                                    [style]="'primary'"
                                    [type]="'button'"
                                    (onClick)="onClickContinueGuest()"
                                >
                                    {{
                                        'fe_precheckin_step0_button_txt_guest'
                                            | translate
                                    }}
                                </fe-button>
                            </div>
                        </div>
                    </div>
                    <div class="container-fluid gx-13 gx-sm-0">
                        <p class="title-need-help fw-bold m-0 mb-1">
                            {{ 'fe_precheckin_step0_p_need_help' | translate }}
                        </p>
                        <fe-button
                            [btnClass]="'fw-normal p-0'"
                            [style]="'link'"
                            class="btn-help mb-1"
                            (onClick)="onClickDidPrecheckin()"
                        >
                            {{
                                'fe_precheckin_step0_p_checkin_ask' | translate
                            }}
                        </fe-button>
                        <fe-button
                            [btnClass]="'fw-normal p-0 text-start'"
                            [style]="'link'"
                            class="btn-help btn-help-tips"
                            (onClick)="onClickTips()"
                        >
                            {{
                                'fe_precheckin_step0_p_checkin_advices'
                                    | translate
                            }}
                        </fe-button>
                        <hr class="mt-6 mb-6 opacity-100 separation" />
                        <fe-button
                            [btnClass]="
                                'fw-normal p-0 text-decoration-underline'
                            "
                            [style]="'link'"
                            class="btn-help btn-need-assistance"
                            [icon]="'arrow-right-yellow'"
                            [iconPosition]="'right'"
                            [href]="'contact-us-and-faqs' | formatUrl"
                        >
                            {{
                                'fe_precheckin_step0_p_checkin_need_assistance'
                                    | translate
                            }}
                        </fe-button>
                    </div>
                </fe-primary-container>
            </div>
            <div class="col-12 col-lmd-6">
                <div
                    class="container-fluid gx-16 empty-container whatis-precheckin-container"
                >
                    <div class="row">
                        <div class="col d-flex justify-content-center">
                            <img
                                class="mt-21 whatis-precheckin-container-img"
                                src="https://www.alamo.com.mx/assets/img/img179.webp"
                                alt="precheckin info"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <p class="title fw-bold mb-6">
                                {{
                                    'fe_precheckin_step0_p_checkin_subtitle_why_precheckin'
                                        | translate
                                }}
                            </p>
                            <p class="info">
                                {{
                                    'fe_precheckin_step0_p_checkin_info_why_precheckin'
                                        | translate
                                }}
                            </p>
                            <p class="title fw-bold mb-6">
                                {{
                                    'fe_precheckin_step0_p_checkin_subtitle_ready_start'
                                        | translate
                                }}
                            </p>
                            <ul class="list-info">
                                <li class="info">
                                    {{
                                        'fe_precheckin_step0_p_checkin_info_item1_ready_start'
                                            | translate
                                    }}
                                </li>
                                <li class="info">
                                    {{
                                        'fe_precheckin_step0_p_checkin_info_item2_ready_start'
                                            | translate
                                    }}
                                </li>
                                <li class="info">
                                    {{
                                        'fe_precheckin_step0_p_checkin_info_item3_ready_start'
                                            | translate
                                    }}
                                    <span class="fw-bold">
                                        {{
                                            'fe_precheckin_step0_span_checkin_info_item3_ready_start_bold'
                                                | translate
                                        }}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</fe-primary-container>
<section class="options mb-26 mb-sm-20">
    <div class="options__container container px-4 px-slmd-6 px-xl-8">
        <div class="options__container__top pt-4">
            <p class="fw-bold mb-0">
                {{ 'fe_precheckin_step0_options_top_title' | translate }}
            </p>
        </div>
        <hr class="options__container__separator opacity-100 my-1" />
        <div class="options__container__bottom py-4">
            <div class="row">
                <div class="col-12 col-slmd-6">
                    <div class="d-flex flex-column flex-slmd-row">
                        <img
                            class="align-self-center mb-2 mb-slmd-0"
                            [src]="'images/servicio-mostrador.svg' | cdn"
                            alt="on desk service"
                        />
                        <p
                            class="options__container__bottom__subtitle fw-bold ms-2 mb-0 align-self-center"
                        >
                            {{
                                'fe_precheckin_step0_options_bottom_first_col_title'
                                    | translate
                            }}
                        </p>
                    </div>
                    <p
                        class="options__container__bottom__description pt-2 text-center text-slmd-start"
                    >
                        {{
                            'fe_precheckin_step0_options_bottom_first_col_description'
                                | translate
                        }}
                    </p>
                </div>
                <div class="col-12 col-slmd-6">
                    <div class="d-flex flex-column flex-slmd-row">
                        <img
                            class="align-self-center mb-2 mb-slmd-0"
                            [src]="'images/registro-rapido.svg' | cdn"
                            alt="on desk service"
                        />
                        <p
                            class="options__container__bottom__subtitle fw-bold ms-2 mb-0 align-self-center"
                        >
                            {{
                                'fe_precheckin_step0_options_bottom_second_col_title'
                                    | translate
                            }}
                        </p>
                    </div>
                    <p
                        class="options__container__bottom__description pt-2 text-center text-slmd-start"
                    >
                        {{
                            'fe_precheckin_step0_options_bottom_second_col_description'
                                | translate
                        }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
<fe-footer></fe-footer>
